import React from 'react';
import { useAppConfigContext } from 'src/viewLayer/components/contexts/AppConfigContext';
import { useEmailPagePath } from 'src/viewLayer/navigation';
import { onBackButtonClicked } from 'src/viewLayer/helpers/safeNativeReporter';
import TrackableLink from 'src/viewLayer/components/shared/TrackableLink';
import BACK_ARROW_IMAGE from 'src/viewLayer/components/pages/BackButton/back-arrow.svg';
import './index.scss';

export default (props) => {
  const { devicePath } = useAppConfigContext();

  const isNativeMobileAndEmailView = devicePath === 'login-mobile' && props.path === 'email';
  const isNativeMobileAndPasswordView = devicePath === 'login-mobile' && props.path === 'password';
  const isNativeMobileAndBusinessView = devicePath === 'login-mobile' && props.path === 'business';

  // Back button in email and business view native
  if (isNativeMobileAndEmailView || isNativeMobileAndBusinessView) {
    const trackingId = isNativeMobileAndEmailView ? 'email_back_button_webview' : 'b2b_sso_back_button_webview';
    return (
      <TrackableLink
        {...props}
        className="BackButton"
        data-testid="back-button-webview"
        onClick={onBackButtonClicked}
        trackingId={trackingId}
      >
        <img src={BACK_ARROW_IMAGE} alt={'Back arrow'} />
      </TrackableLink>
    );
  }

  // Back button in password view native
  if (isNativeMobileAndPasswordView) {
    return (
      <TrackableLink
        {...props}
        className="BackButton"
        data-testid="back-button-default"
        spaHREF={useEmailPagePath()}
      >
        <img src={BACK_ARROW_IMAGE} alt={'Back arrow'} />
      </TrackableLink>
    );
  }

  return null;
};
